import {userConstants} from '../constants'

const initialState = {
    loggingIn: false,
    loggedIn: false,
    checkingLoginStatus: true,
    fetchingUserProfile: true,
    messages: [],
    errors: [],
    token: '',
    displayname: '',
    firstname: '',
    lastname: '',
    euid: '',
    emplid: '',
    emailaddr: '',
    roles: {},
    admin: false,
    exp: '',
}

export function authentication(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                ...state,
                loggingIn: true,
                loggedIn: false,
                messages: state.messages.concat([
                    {body: 'Logging in...', time: new Date()},
                ]),
                token: '',
            }
        case userConstants.LOGIN_SUCCESS:
            return {
                ...state,
                messages: state.messages.concat([
                    {body: 'Logged in Success', time: new Date()},
                ]),
                loggingIn: false,
                loggedIn: true,
                token: action.token,
                displayname: action.displayname,
                firstname: action.firstname,
                lastname: action.lastname,
                euid: action.euid,
                emplid: action.emplid,
                exp: action.exp,
            }
        case userConstants.LOGIN_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                loggingIn: false,
                loggedIn: false,
                token: '',
                displayname: '',
                firstname: '',
                lastname: '',
                euid: '',
                emplid: '',
                exp: '',
            }
        case userConstants.LOGOUT:
            return {
                ...state,
                messages: state.messages.concat([
                    {body: 'Logged Out', time: new Date()},
                ]),
                loggingIn: false,
                loggedIn: false,
                token: '',
                displayname: '',
                firstname: '',
                lastname: '',
                euid: '',
                emplid: '',
                exp: '',
            }
        case userConstants.LOGIN_CHECK:
            return {
                ...state,
                checkingLoginStatus: true,
            }
        case userConstants.LOGIN_ACTIVE:
            return {
                ...state,
                messages: state.messages.concat([
                    {body: 'Verified Token Valid', time: new Date()},
                ]),
                loggingIn: false,
                loggedIn: true,
                checkingLoginStatus: false,
            }
        case userConstants.LOGIN_GETUSERPROFILE_REQUEST:
            return {
                ...state,
                messages: state.messages.concat([
                    {body: 'Retrieving user profile...', time: new Date()},
                ]),
                fetchingUserProfile: true,
                emailaddr: '',
                roles: {},
                admin: false,
            }
        case userConstants.LOGIN_GETUSERPROFILE_SUCCESS:
            return {
                ...state,
                messages: state.messages.concat([
                    {body: 'Retrieved User Profile', time: new Date()},
                ]),
                fetchingUserProfile: false,
                emailAddress: action.data.emailAddress,
                roles: action.data.roles ? action.data.roles : {},
                admin: action.data.admin ? action.data.admin : false,
                departmentslist:
                    typeof action.data.roles != 'undefined'
                        ? Array.isArray(action.data.roles.admin)
                            ? Array.isArray(action.data.roles.creator)
                                ? action.data.roles.admin.concat(
                                      action.data.roles.creator
                                  )
                                : action.data.roles.admin
                            : []
                        : [],
            }
        case userConstants.LOGIN_GETUSERPROFILE_FAILURE:
            return {
                ...state,
                errors: state.errors.concat([
                    {
                        body: action.message,
                        time: new Date(),
                    },
                ]),
                fetchingUserProfile: false,
                emailAddress: '',
                roles: {},
                admin: false,
            }
        default:
            return state
    }
}
